import React from "react";
import { Button } from "antd";

function LastStepButtons(props) {
    return (
       <React.Fragment>
            <div className="button-wrapper">
                <Button className="back-btn" onClick={props.handleBack}>
                    Back
                </Button>
            </div>
            <div className="button-wrapper next-button">
                <Button
                    className="finish-setup-btn"
                    type="primary"
                    onClick={props.handleSubmit}
                    loading={props.isLoading}>
                    Finish Setup
                </Button>
            </div>
       </React.Fragment>
    )
}

export default LastStepButtons
